document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-item__linked-item').forEach(function (el) {
    el.addEventListener('mouseenter', function () {
      var productCard = el.closest('.product-card, [product-card]');
      if (!productCard) return;
      var img = productCard.querySelector('.product-card__img');

      var newImgUrl = el.getAttribute('url_img') || el.getAttribute('data-url_img');
      if (img && newImgUrl) {
        img.dataset.originalSrc = img.dataset.originalSrc || img.src;
        img.src = newImgUrl;
        img.removeAttribute('srcset');
      }
    });
  });
});